<pf-text bold>{{ changeText }}</pf-text>
<pf-text class="changed-fields">{{ changedFields }}</pf-text>
<platform-change-tree
    [autoExpand]="autoExpand"
    [entityName]="entityName"
    [entityChange]="entityChange"
    [customValueTransformer]="customValueTransformer"></platform-change-tree>
